import React from 'react';
import { Breadcrumbs, Link, Box, Typography } from '@mui/material';
import { breakpoints } from '@next/themes';
import { styled } from '@mui/material/styles';

const StyledBreadcrumbs = styled(Breadcrumbs, {
    shouldForwardProp: p => p !== "isHomeIcon",
}) `
    width: 100%;
    overflow: hidden;
    height: 2.25rem;
    display: flex;
    align-items: center;
    padding-left: 1rem;
    @media (min-width: ${breakpoints.values.md}px) {
        padding-left: 2rem;
    }
    @media (min-width: ${breakpoints.values.lg}px) {
        padding-left: ${({ isHomeIcon }) => (isHomeIcon ? `0.25rem` : `1rem`)};
    }
    ol {
        display: flex;
        flex-wrap: nowrap;
        overflow-x: auto;
        -ms-overflow-style: none;
        scrollbar-width: none;
        padding-right: 3rem;
    }

    ol::-webkit-scrollbar {
        display: none;
    }
`;
const StyledLink$1 = styled(Link) `
    color: ${({ theme }) => theme.colours.palette.text.primary};
    font-family: ${({ theme }) => theme.colours.typography.body2.fontFamily};
    font-size: ${({ theme }) => theme.colours.typography.body2.fontSize};
    font-weight: ${({ theme }) => theme.colours.typography.body2.fontWeight};
    letter-spacing: ${({ theme }) => theme.colours.typography.body2.letterSpacing};
    line-height: ${({ theme }) => theme.colours.typography.body2.lineHeight};
    text-transform: capitalize;
    display: flex;
    align-items: center;
    white-space: nowrap;
`;
const StyledSemiTransparentBox = styled(Box) `
    @media (max-width: ${breakpoints.values.lg - 1}px) {
        height: 2.25rem;
        position: absolute;
        background: ${props => props.theme.direction === "ltr"
    ? props.theme.colours.components.breadcrumb.default.gradientRight
    : props.theme.colours.components.breadcrumb.default.gradientLeft};
        left: ${props => props.theme.direction === "ltr" ? "auto" : 0};
        right: ${props => props.theme.direction === "rtl" ? "auto" : 0};
        width: 16px;
        z-index: 2;
        pointer-events: none;
    }
`;
const StyledWrapper = styled(Box) `
    display: flex;
    align-items: center;
    width: 100%;
    height: 2.25rem;
    width: 100%;
    margin-left: auto;
    box-sizing: border-box;
    margin-right: auto;
    max-width: 1280px;
`;

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

const StyledImage$1 = styled("svg") `
    width: 1.5rem;
    height: 1.5rem;
    color: ${({ theme }) => theme.colours.components.breadcrumb.default.button.enabled.iconColor};
    transform: ${props => (props.theme.direction === "ltr" ? "rotate(0deg)" : "rotate(180deg)")};

    &:hover {
        color: ${({ theme }) => theme.colours.components.breadcrumb.default.button.hovered.iconColor};
    }
`;
const StyledLink = styled(Link, {
    shouldForwardProp: prop => !String(prop).startsWith("isBackButton"),
}) `
    align-items: center;
    height: 2.25rem;
    padding-right: 1rem;
    padding-left: 0.5rem;
    background-color: ${({ theme }) => theme.colours.components.breadcrumb.default.button.enabled.backgroundColor};
    margin-left: 2.5rem;
    border-top: ${({ theme }) => `1px solid ${theme.colours.components.breadcrumb.default.button.enabled.borderTopColor}`};
    border-bottom: ${({ theme }) => `1px solid ${theme.colours.components.breadcrumb.default.button.enabled.borderBottomColor}`};
    border-left: ${({ theme }) => `1px solid ${theme.colours.components.breadcrumb.default.button.enabled.borderLeftColor}`};
    border-right: ${({ theme }) => `1px solid ${theme.colours.components.breadcrumb.default.button.enabled.borderRightColor}`};
    @media (max-width: ${breakpoints.values.lg - 1}px) {
        margin-left: 1rem;
    }

    color: ${({ theme }) => theme.colours.components.breadcrumb.default.button.enabled.contrastTextColor};
    font-family: ${({ theme }) => theme.colours.typography.body2.fontFamily};
    font-size: ${({ theme }) => theme.colours.typography.body2.fontSize};
    font-weight: ${({ theme }) => theme.colours.typography.body2.fontWeight};
    line-height: ${({ theme }) => theme.colours.typography.body2.lineHeight};
    text-decoration: none;
    &:focus,
    &:hover,
    &:visited,
    &:link,
    &:active {
        text-decoration: none;
    }

    &:hover {
        border-top: ${({ theme }) => `1px solid ${theme.colours.components.breadcrumb.default.button.hovered.borderTopColor}`};
        border-bottom: ${({ theme }) => `1px solid ${theme.colours.components.breadcrumb.default.button.hovered.borderBottomColor}`};
        border-left: ${({ theme }) => `1px solid ${theme.colours.components.breadcrumb.default.button.hovered.borderLeftColor}`};
        border-right: ${({ theme }) => `1px solid ${theme.colours.components.breadcrumb.default.button.hovered.borderRightColor}`};
        background-color: ${({ theme }) => theme.colours.components.breadcrumb.default.button.hovered.backgroundColor};
        color: ${({ theme }) => theme.colours.components.breadcrumb.default.button.hovered.contrastTextColor};
    }
    display: ${({ isBackButton }) => (isBackButton ? `flex` : `none`)};
`;

const BackLink = (_a) => {
    var { backText } = _a, props = __rest(_a, ["backText"]);
    return (React.createElement(StyledLink, Object.assign({ "data-testid": "breadcrumbs-back-button", "aria-label": "Breadcrumbs Back Button" }, props),
        React.createElement(StyledImage$1, { "aria-label": "Breadcrumbs Back Icon" },
            React.createElement("use", { xlinkHref: "/static-content/icons/shared/ui-components/breadcrumb/chevron-left.svg#chevron-left", href: "/static-content/icons/shared/ui-components/breadcrumb/chevron-left.svg#chevron-left" })),
        React.createElement(Typography, { variant: "body2" }, backText)));
};

const StyledImage = styled("img", {
    shouldForwardProp: prop => !String(prop).startsWith("is"),
}) `
    color: ${({ theme }) => theme.colours.palette.primary.light};
    display: ${({ isHomeIcon }) => (isHomeIcon ? `flex` : `none`)};
    margin-right: 0.375rem;
    margin-left: 0;
    @media (min-width: ${breakpoints.values.lg}px) {
        margin-left: 1.5rem;
    }
    @media (min-width: ${breakpoints.values.xl}px) {
        margin-left: ${({ isBackButton }) => (isBackButton ? `1.5rem` : `2.25rem`)};
    }
`;

const HomeIcon = ({ isHomeIcon, homeIcon, homeText, isBackButton }) => (React.createElement(React.Fragment, null,
    React.createElement(StyledImage, { isHomeIcon: isHomeIcon, isBackButton: isBackButton, src: homeIcon, alt: "Breadcrumbs Home Icon" }),
    homeText !== "" && React.createElement(Typography, { variant: "body2" }, homeText)));

const BreadcrumbsUIComponent = ({ expandText, itemsAfterCollapse, itemsBeforeCollapse, maxItems, separator, urlSegments, isHomeIcon, isBackButton, homeIcon, homeUrl, backUrl, backText, homeText, }) => {
    return (React.createElement(StyledWrapper, null,
        React.createElement(StyledSemiTransparentBox, null),
        React.createElement(BackLink, { href: backUrl, backText: backText, isBackButton: isBackButton }),
        React.createElement(StyledBreadcrumbs, { expandText: expandText, itemsAfterCollapse: itemsAfterCollapse, itemsBeforeCollapse: itemsBeforeCollapse, maxItems: maxItems, separator: separator, isHomeIcon: isHomeIcon, role: "navigation", "data-testid": "plp-breadcrumbs-navigation-list", id: "plp-breadcrumbs-navigation-list", "aria-label": "Breadcrumbs Menu" },
            React.createElement(StyledLink$1, { underline: "hover", href: homeUrl, "data-testid": "breadcrumbs-home-link", id: "breadcrumbs-home-link", "aria-label": "Breadcrumbs Home Link" },
                React.createElement(HomeIcon, { isHomeIcon: isHomeIcon, homeIcon: homeIcon, isBackButton: isBackButton, homeText: homeText })),
            urlSegments.map(urlSegment => (React.createElement(StyledLink$1, { underline: "hover", variant: "body2", "data-testid": `breadcrumb-${urlSegment.text}-link`, href: urlSegment.link, key: urlSegment.link, "aria-current": "location" },
                React.createElement(Typography, { variant: "body2" }, urlSegment.text)))))));
};

export { BreadcrumbsUIComponent };
